import styled from "styled-components/macro";

export const CommonWrapper = styled.div`
  &.common-styles {
    display: flex;
    flex-direction: column;
    height: 100vh;
    justify-content: space-between;
  }

  &.common-loading {
    display: flex;
    height: 100vh;
    align-items: center;
    justify-content: center;
  }

  .loading-state {
    display: flex;
    align-items: center;
    gap: 12px;
  }
`;

export const MarketplaceApprovalStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;

  .info-header {
    h2 {
      color: var(--Neutral-100);
      font-size: 24px;
      font-weight: 600;
      line-height: 32px;
      letter-spacing: -0.48px;
    }
  }

  .approval-information-container {
    display: flex;
    flex-direction: column;
    gap: 24px;

    &.user-approval {
      justify-content: space-between;
    }
  }

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const ApprovalInformationSection = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  &.footer-section {
    width: 100%;
  }

  &.user-approval {
    width: max-content;
    flex-direction: row;

    button {
      padding: 10px 20px;
    }
  }
  .section-title {
    color: var(--Neutral-100);
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.3px;
  }

  span {
    color: var(--Neutral-60);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.18px;
  }

  p {
    color: var(--Neutral-100);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .approval-details-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    padding: 0;
    margin: 0;
    list-style: none;

    .profile-info {
      display: flex;
      align-items: center;
      gap: 8px;

      img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        object-fit: cover;
      }
    }

    li {
      display: flex;
      flex-direction: column;
      gap: 4px;
      overflow: hidden;

      a {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: var(--Neutral-100);
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.16px;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: auto;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;

        &.link_color {
          color: var(--Active-100);
        }
      }
    }
  }

  .common-details {
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow: hidden;
  }

  .categories-card {
    .tags {
      display: flex;
      align-items: center;
      gap: 8px;

      span {
        border: 1px solid #1f1f1f;
        border-radius: 24px;
        height: 24px;
        padding: 4px 8px;
        display: flex;
        align-items: center;
        color: #1f1f1f;
      }
    }
  }

  .decision-section {
    display: flex;
    gap: 12px;
    justify-content: space-between;

    .decision-group {
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;
    }

    .pill-container {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;

      .approve {
        min-width: 100px;
      }

      .reject {
        min-width: 100px;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 8px;
    gap: 12px;

    &.user-approval {
      flex-direction: column;
      width: 100%;
      position: sticky;
      bottom: 0;
      background: #fff;
      border-top: 1px solid var(--Neutral-8);

      button {
        padding: 10px;
      }
    }

    .section-title {
      &.decision {
        display: none;
      }
    }

    .common-details {
      p {
        font-size: 14px;
      }
    }

    .approval-details-grid {
      gap: 16px;
      grid-template-columns: repeat(2, 2fr);
    }

    .categories-card {
      .tags {
        flex-wrap: wrap;
      }
    }

    .decision-section {
      flex-wrap: wrap;
      gap: 8px;

      .decision-group {
        gap: 8px;
        flex-wrap: wrap;
      }

      .pill-container {
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 4px;

        .approve {
          width: max-content;
        }
        .reject {
          width: max-content;
        }
      }
    }
  }
`;
